export class BaseTime{
    public shiftTimeStart: string
    public shiftTimeEnd: string
    public teleworkStart1: string
    public teleworkEnd1: string
    public teleworkStart2: string
    public teleworkEnd2: string
    public restTimeStart1: string
    public restTimeEnd1: string
    public restTimeStart2: string
    public restTimeEnd2: string
    public restTimeStart3: string
    public restTimeEnd3: string
    public restTimeStart4: string
    public restTimeEnd4: string
    public restTimeStart5: string
    public restTimeEnd5: string
    public restTimeStart6: string
    public restTimeEnd6: string
    public restTimeStart7: string
    public restTimeEnd7: string
    public restTimeStart8: string
    public restTimeEnd8: string
    public restTimeStart9: string
    public restTimeEnd9: string
    public restTimeStart10: string
    public restTimeEnd10: string
    public morningOffTimeStart: string
    public morningOffTimeEnd: string
    public afternoonOffTimeStart: string
    public afternoonOffTimeEnd :string
}
